import type React from 'react';

/**
 * The label full/short map, copied from server.js's SHORT_LABELS by a script rather than by hand.
 *
 * `lbl()` renders the pair as two spans; public/app.css shows the short one when the container is narrow.
 * A page that renders only the full label looks right until the card is narrow, and then wraps instead of
 * shortening — the drift the design system exists to stop.
 */
const SHORT_LABELS: Record<string, string> = {
  'ac/share': 'ac/s',
  'cost basis': 'cost',
  'day change': 'day',
  'day change $ (%)': 'day $ (%)',
  'dividend ($)': 'div ($)',
  'dividends': 'div',
  'due to investments': 'due to inv.',
  'estimated tax': 'Est. Tax',
  'holdings value': 'holdings val',
  'install': 'where',
  'last start': 'started',
  'needed by': 'needed',
  'next run': 'next',
  'prerequisite': 'requires',
  'spread value': 'spread',
  'service': 'svc',
  'long-term gains': 'lt gains',
  'window closes': 'closes',
  'market value': 'market',
  'payments (12mo)': 'pmts (12mo)',
  'payments left': 'pmts left',
  'projected rest of year': 'projected rest',
  'quantity': 'qty',
  'quarter': 'qtr',
  'realized': 'real',
  'realized in quarter': 'realized in qtr',
  'shares (all users)': 'shares (all)',
  'short-term gains': 'st gains',
  'symbols': 'sym',
  'tax from investments': 'tax (inv)',
  'taxable amount': 'taxable amt',
  'taxable dividends': 'tax (div)',
  'transactions': 'txs',
  'unrealized': 'unreal',
  'unrealized gain/loss': 'unrealized',
  'with investments': 'w/ investments'
};

export function lbl(full: string): React.ReactNode {
  const key = String(full).trim().toLowerCase();
  const short = Object.prototype.hasOwnProperty.call(SHORT_LABELS, key) ? SHORT_LABELS[key] : key;
  if (short && short !== key) {
    return (
      <>
        <span className="label-full">{full}</span>
        <span className="label-short">{short}</span>
      </>
    );
  }
  return full;
}
